import * as React from "react"
import type { SVGProps } from "react"
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.14a7.7 7.7 0 0 1-5.67-2.32A7.7 7.7 0 0 1 4 12.14Q4 8.8 6.33 6.47A7.7 7.7 0 0 1 12 4.14q1.73 0 3.3.72A8 8 0 0 1 18 6.89V5.14q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.3.29.71v5q0 .43-.29.72a1 1 0 0 1-.71.28h-5a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h3.2a6 6 0 0 0-2.19-2.2 6 6 0 0 0-3.01-.8q-2.5 0-4.25 1.75A5.8 5.8 0 0 0 6 12.14q0 2.5 1.75 4.25A5.8 5.8 0 0 0 12 18.14q1.7 0 3.11-.86a6 6 0 0 0 2.19-2.31 1 1 0 0 1 .56-.49q.36-.15.74-.01a1 1 0 0 1 .57.52.8.8 0 0 1-.02.75 8 8 0 0 1-2.92 3.2 8 8 0 0 1-4.23 1.2" />
  </svg>
)
export default SvgRefresh
